import React from 'react'

function Separator() {
  return (
    <div className="border-[#7f7f7f] border-b  m-10" />

  )
}

export default Separator